export default __webpack_public_path__ + "static/media/machine-girl.24d2c6db.webp";